// Stock Adjustment Reason Codes
// see: app/models/stock_adjustment.rb, REASON_CODES
export const REASON_CODES = [
  'DAMAGED',
  'EXPIRED',
  'COUNT_ERROR',
  'DATA_ENTRY_ERROR',
  'QUALITY_CHECK_FAILED',
  'OTHER'
];
